export enum AuthenticationProvider {
    HALOB = 'halob',
    AAD = 'aad',
    HALOC = 'haloc',
    MULESOFT = 'mulesoft'
}

export const domainsToAuthenticationMap: { [key: string]: AuthenticationProvider } = {
    'dynamicdefense.att.com': AuthenticationProvider.HALOB,
    'dynamicdefense-stage.att.com': AuthenticationProvider.HALOB,
    'dynamicdefense-dev.att.com': AuthenticationProvider.HALOB,
    'dynamicdefense-ci.att.com': AuthenticationProvider.HALOB,
    'dynamicdefense-testa.att.com': AuthenticationProvider.HALOB,

    'dynamicdefense.it.att.com': AuthenticationProvider.AAD,
    'dynamicdefense.stage.att.com': AuthenticationProvider.AAD,
    'dynamicdefense.dev.att.com': AuthenticationProvider.AAD,
    'dynamicdefense-ci.dev.att.com': AuthenticationProvider.AAD,
    'dynamicdefense-testa.dev.att.com': AuthenticationProvider.AAD,
    'dynamicdefense-demo.dev.att.com': AuthenticationProvider.AAD,
    'localhost': AuthenticationProvider.AAD,

    'dynamicdefense-c-dev.att.com': AuthenticationProvider.HALOC,
    'dynamicdefense-c-testa.att.com': AuthenticationProvider.HALOC,
    'dynamicdefense-c-ci.att.com': AuthenticationProvider.HALOC,
    'dynamicdefense-c-stage.att.com': AuthenticationProvider.HALOC,
    'mydynamicdefense.att.com': AuthenticationProvider.HALOC,

    'dynamicdefense-api.dev.att.com': AuthenticationProvider.MULESOFT,
    'dynamicdefense-api.stage.att.com': AuthenticationProvider.MULESOFT,
    'dynamicdefense-api.it.att.com': AuthenticationProvider.MULESOFT,
    'dynamicdefense-testa-api.dev.att.com': AuthenticationProvider.MULESOFT,
    'dynamicdefense-ci-api.dev.att.com': AuthenticationProvider.MULESOFT
};